import type {
  ShellNavChildLink,
  ShellNavChildRoute,
  ShellNavGroup,
  ShellNavTaxonomyEntity,
} from '@/shared/shell/nav.types.js';
import {
  isShellNavChildFormDrawer,
  isShellNavChildQuickPanel,
  isShellNavChildRoute,
} from '@/shared/shell/nav.types.js';

export function isShellNavPathActive(
  pathname: string,
  item: { path?: string; matchPrefix?: string },
): boolean {
  if (item.path === undefined && item.matchPrefix === undefined) {
    return false;
  }

  const prefix = item.matchPrefix ?? item.path;
  if (prefix === undefined) {
    return false;
  }

  if (prefix === '/') {
    return pathname === '/';
  }

  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

export function isShellNavChildActive(pathname: string, child: ShellNavChildRoute): boolean {
  if (child.enabled === false) {
    return false;
  }

  if (child.matchPrefix === child.path) {
    return pathname === child.path || pathname.startsWith(`${child.path}/`);
  }

  return isShellNavPathActive(pathname, child);
}

export function isShellNavChildLinkActive(
  pathname: string,
  child: ShellNavChildLink,
  activeQuickPanelEntity: ShellNavTaxonomyEntity | null,
): boolean {
  if (isShellNavChildRoute(child)) {
    return isShellNavChildActive(pathname, child);
  }

  if (isShellNavChildQuickPanel(child)) {
    return activeQuickPanelEntity === child.entity;
  }

  if (isShellNavChildFormDrawer(child)) {
    return false;
  }

  return false;
}

export function isShellNavGroupActive(pathname: string, entry: ShellNavGroup): boolean {
  if (isShellNavPathActive(pathname, entry)) {
    return true;
  }

  return entry.children.some((child) => isShellNavChildLinkActive(pathname, child, null));
}
